var render = function render(){var _vm=this,_c=_vm._self._c;return _c('overview-card',{attrs:{"noEdit":true,"title":_vm.title}},[_c('v-row',{staticClass:"ml-2 pb-3"},[_c('v-col',{attrs:{"cols":"12"}},[(!_vm.notes)?_c('span',{staticClass:"noData"},[_vm._v("No notes to display")]):_c('span',[_vm._v(_vm._s(_vm.notes))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }